<template>
  <v-card flat style="margin: 1px 0;" @click="onFoodCardClick(food)">
    <v-layout row wrap>
      <v-flex xs5 md3>
        <div v-if="food.imageurls.length==0" style="heigth:150px;padding-top:65px;">
          <v-progress-circular
            indeterminate
            color="grey lightn-3"
          ></v-progress-circular>
        </div>
        <v-img v-else 
          v-lazy:background-image="food.thumnail"
          height="150px" max-width="150px" aspect-ratio="0.5" :alt="food.name"
          
        />
      </v-flex>
      <v-flex xs7 md9 style="text-align:left;padding:10px 0;">
        <div style="font-size:13pt;font-weight:bold;" >
          {{food.name}}
        </div>
        <div style="text-align:left;padding:5px 0;overflow-x: auto;white-space:nowrap;">
          <v-chip v-if="food.categoryname" small label color="primary" dark>{{food.categoryname.value}}</v-chip>
          <v-chip  color="red" outline small v-for="(tag, id) in Object.keys(food.tags)" :key=id>{{tag}}</v-chip>
        </div>
        <v-flex xs12>
          <span v-if="food.hotScore>0" style="font-weight:bold;margin-right:10px;font-size:110%;">
            辛さ：{{food.hotScore}}
          </span>
          <span v-if="food.tasteScore>0" style="font-weight:bold;font-size:110%;">
            味：{{food.tasteScore}}
          </span>
        </v-flex>
        <span v-if="food.postCount" class="primary--text">
          <v-icon small color="primary">chat_bubble</v-icon>&nbsp;{{food.postCount}}件
        </span>
        <span v-if="food.tabetaiCount" class="primary--text">
          <v-icon small color="primary">favorite_border</v-icon>&nbsp;{{food.tabetaiCount}}件
        </span>

      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: 'FoodCard',
  props: {
    food: Object,
    images: Array
  },
  methods: {
    onFoodCardClick (food) {
      this.$router.push({name: 'searchFoodDetail', params: {id: food.id}})
    }
  }
}
</script>

<style scoped>
</style>